import { render, staticRenderFns } from "./CreateProductVariantModal.vue?vue&type=template&id=287dccaa&"
import script from "./CreateProductVariantModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductVariantModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductVariantModal.vue?vue&type=style&index=0&id=287dccaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports